<p-tag [id]="id() + '-tag'" [severity]="severity()" [value]="label() | translate" [rounded]="rounded()"></p-tag>
